module.exports = __webpack_public_path__ + "static/media/19.86166cdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/19.png
// module id = 1392
// module chunks = 0